/**
 * Custom error classes for productivity goals app
 */

export class RateLimitError extends Error {
  constructor(
    public retryAfter: number, // seconds until retry allowed
    message?: string
  ) {
    super(message || 'Rate limit exceeded. Please try again later.');
    this.name = 'RateLimitError';
  }

  getRetryTimeString(): string {
    const hours = Math.floor(this.retryAfter / 3600);
    const minutes = Math.floor((this.retryAfter % 3600) / 60);

    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else {
      return 'a few moments';
    }
  }
}

export class TurnstileError extends Error {
  constructor(message?: string) {
    super(message || 'Security verification failed. Please refresh and try again.');
    this.name = 'TurnstileError';
  }
}

export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class APIError extends Error {
  constructor(
    public status: number,
    message: string
  ) {
    super(message);
    this.name = 'APIError';
  }
}
